// Given a cookie key `name`, returns the value of
// the cookie or `null`, if the key is not found.
export function getCookie(name: string): string | null {
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(";")
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null
  );
}
export function deleteCookie(name: string) {
  const domain = process.env.NODE_ENV === "production" ? ".jaasper.com" : ".jaas.eu";
  console.log("deleeting cookie " + name + " for environment " + domain);
  document.cookie = `${name}=; ` + `Expires=Thu, 01 Jan 1970 00:00:00 GMT; ` + `Path=/; ` + `Domain=${domain}; ` + `Secure; ` + `SameSite=None`;
}
